<template>
  <div>
    <v-container class="pl-10 pr-10">
      <v-flex lg12 sm12 xs12>
        <p class="display-1 mt-7">상품 정보 관리/등록</p>
        <p class="mb-0 subtitle-1 font-weight-light">
          정품 인증 코드를 생성하기 위한 상품 정보를 등록하고 관리하는 메뉴입니다.
        </p>
        <p class="mb-0 subtitle-1 font-weight-light">
          개별 또는 엑셀 일괄 상품 등록이 가능합니다.
        </p>

        <v-tabs class="mt-10">
          <!--
          상품관리 contents 영역
          -->
          <v-tab class="title">상품 관리</v-tab>
          <v-tab-item>
            <ManageProduct></ManageProduct>
          </v-tab-item>

          <!--
          개별 상품 등록 contents 영역
          -->
          <v-tab class="title">개별 상품 등록</v-tab>
          <v-tab-item>
            <RegisterProduct></RegisterProduct>
          </v-tab-item>

          <!--
          엑셀 상품 등록 contents 영역
          -->
          <v-tab class="title">엑셀 상품 등록</v-tab>
          <v-tab-item>
            <ExcelRegisterProduct></ExcelRegisterProduct>
          </v-tab-item>
        </v-tabs>
      </v-flex>
    </v-container>
  </div>
</template>

<script>
import ManageProduct from "@/components/shoplus_authservice/manageProductInfo/ManageProduct.vue";
import RegisterProduct from "@/components/shoplus_authservice/manageProductInfo/RegisterProduct.vue";
import ExcelRegisterProduct from "@/components/shoplus_authservice/manageProductInfo/ExcelRegisterProduct.vue";

export default {
  components: {
    ManageProduct,
    RegisterProduct,
    ExcelRegisterProduct,
  },
};
</script>
